import gql from 'graphql-tag'

const GerarPushSubscriptionGql = gql`
  mutation GerarPushSubscription($input: PushSubscriptionInput!) {
    gerarPushSubscription(pushSubscriptionInput: $input)
  }
`

export const register = (vapidPublicKey, client) => {
  const isServiceWorker = 'serviceWorker' in navigator
  const isNotification = 'Notification' in window
  const isEdge = navigator.userAgent.indexOf('Edge') > -1

  if (isServiceWorker && isNotification && !isEdge) {
    navigator.serviceWorker.register(`/sw-portal.js`).then(() => {
      Notification.requestPermission(permission => {
        if (permission === 'granted') {
          registerSubscription(vapidPublicKey, client)
        }
      })
    })
  }
}

const registerSubscription = (vapidPublicKey, client) => {
  navigator.serviceWorker.ready.then(registration => {
    // Safari supports push notifications, but does not support
    // the standardized W3C push notifications that
    // navigator.serviceWorker.getRegistration() relies on.
    if (registration == null || registration.pushManager == null) {
      return
    }
    registration.pushManager
      .getSubscription()
      .then(subscription => {
        if (subscription) {
          return subscription
        }

        return registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: vapidPublicKey
        })
      })
      .then(subscription => {
        const subscriptionJson = subscription.toJSON()

        generateSubscription(subscriptionJson, client)
      })
  })
}

const generateSubscription = (subscription, client) => {
  client.mutate({
    mutation: GerarPushSubscriptionGql,
    variables: {
      input: {
        endpoint: subscription.endpoint,
        auth: subscription.keys.auth,
        key: subscription.keys.p256dh
      }
    }
  })
}
